import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/AlertDialog/AlertDialog";
import { format } from "date-fns";
import { useRotations } from "../../hooks/rotations/useRotations";
import type { Dispatch, SetStateAction } from "react";

const DeleteRotationDialog = ({
  open,
  onOpenChange,
  setRotations,
  rotation,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  setRotations: Dispatch<SetStateAction<{ rotations: any[]; sessions: any[] }>>;
  rotation: any;
}) => {
  const { deleteRotation, loading } = useRotations();

  const onDelete = async () => {
    const deleted = await deleteRotation(rotation._id);
    if (!deleted) return;

    setRotations((prev) => ({
      rotations: prev.rotations.filter((r) => r._id !== deleted.rotationId),
      sessions: prev.sessions.filter(
        (s) => !deleted.sessionIds.includes(s._id),
      ),
    }));
  };

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            Delete {format(rotation.date, "MMMM dd, yyyy")} Rotation
          </AlertDialogTitle>
          <AlertDialogDescription>
            Are you sure you would like to delete{" "}
            {format(rotation.date, "MMMM dd, yyyy")} rotation and it's sessions?
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={loading.deleteRotation}>
            {loading.deleteRotation ? "Loading..." : "Cancel"}
          </AlertDialogCancel>
          <AlertDialogAction
            variant="destructive"
            onClick={onDelete}
            disabled={loading.deleteRotation}
          >
            {loading.deleteRotation ? "Loading..." : "Delete Rotation"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export { DeleteRotationDialog };
